import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "invitation-wrap" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-head" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "form request")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "activity-list" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: "img/profile_user.jpg",
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Sarah Forgan"),
  /*#__PURE__*/_createTextVNode(" invited you to fill up "),
  /*#__PURE__*/_createVNode("strong", null, "House remodeling form"),
  /*#__PURE__*/_createTextVNode(" at "),
  /*#__PURE__*/_createVNode("strong", null, "09:00 PM"),
  /*#__PURE__*/_createTextVNode(" on "),
  /*#__PURE__*/_createVNode("strong", null, "12 Oct 2020"),
  /*#__PURE__*/_createTextVNode(" . ")
], -1)
const _hoisted_8 = { class: "activity-btn" }
const _hoisted_9 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "btn secondary-btn"
}, "decline", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode("a", {
            href: "#",
            class: "btn default-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.joinInvitation && _ctx.joinInvitation(...args)))
          }, "Accept"),
          _hoisted_9
        ])
      ])
    ])
  ]))
}